import type { ReactElement, SVGProps } from "react";

/** A file glyph with a colored accent and an extension label — the shape
 *  `getFileIcon` (lib/file-icons.tsx) renders per-extension. */
export function ExtensionFileIcon({
  color,
  label,
  ...props
}: SVGProps<SVGSVGElement> & { color: string; label: string }): ReactElement {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* File shape */}
      <path
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
        fill={color}
        opacity={0.15}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Fold */}
      <path
        d="M14 2v6h6"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Extension label */}
      <text
        x="12"
        y="17.5"
        textAnchor="middle"
        fontSize={label.length > 3 ? "5.5" : "6.5"}
        fontWeight="700"
        fontFamily="system-ui, sans-serif"
        fill={color}
      >
        {label}
      </text>
    </svg>
  );
}
